/** Frische-Schwelle für Master-Data-Sync beim Öffnen: 15 Minuten. */
export const MASTER_DATA_MAX_AGE_MS = 15 * 60_000

/**
 * Master-Data gilt als veraltet, wenn nie gesynct (null/leer/unparsbar)
 * oder älter als maxAgeMs.
 */
export function isMasterDataStale(
  syncedAt: string | null | undefined,
  nowMs: number = Date.now(),
  maxAgeMs: number = MASTER_DATA_MAX_AGE_MS,
): boolean {
  if (!syncedAt) return true
  const ts = new Date(syncedAt).getTime()
  if (Number.isNaN(ts)) return true
  return nowMs - ts > maxAgeMs
}

/** True, wenn `after` ein echter zeitlicher Fortschritt gegenüber `before` ist. */
export function syncedAtAdvanced(
  before: string | null | undefined,
  after: string | null | undefined,
): boolean {
  if (!after) return false
  if (!before) return true
  const a = new Date(after).getTime()
  const b = new Date(before).getTime()
  if (Number.isNaN(a)) return false
  if (Number.isNaN(b)) return true
  return a > b
}
